import SectionCard from '../shared/SectionCard'
import { Stack } from './styled-components'
import CommunicationBoardForm from '@/containers/DevToolsNew/CommunicationBoard/CommunicationBoardForm'
import PollResults from '@/containers/DevToolsNew/CommunicationBoard/PollResults/PollResults'

const CommunicationBoardPage = () => {
  return (
    <Stack>
      <SectionCard>
        <CommunicationBoardForm />
      </SectionCard>
      <SectionCard>
        <PollResults />
      </SectionCard>
    </Stack>
  )
}

export default CommunicationBoardPage
